import { Package } from "lucide-react";
import { getImageUrl } from "../lib/formato";
import CelulasValores from "./CelulasValores";

function Foto({ url, nome }) {
  return (
    <div className="w-10 h-10 rounded-lg bg-muted/60 overflow-hidden flex-shrink-0 border border-border/50">
      {url ? (
        <img
          src={getImageUrl(url)}
          alt={nome}
          className="w-full h-full object-cover"
          loading="lazy"
          onError={(e) => { e.target.style.display = "none"; e.target.nextSibling && (e.target.nextSibling.style.display = "flex"); }}
        />
      ) : null}
      <div className={`${url ? "hidden" : "flex"} w-full h-full items-center justify-center`}>
        <Package className="w-4 h-4 text-muted-foreground/40" />
      </div>
    </div>
  );
}

/** Linha de um produto. Dentro de uma categoria aberta (`recuado`) não repete a etiqueta da categoria. */
export default function LinhaProduto({ p, recuado = false }) {
  return (
    <tr className={`border-t hover:bg-muted/20 transition-colors ${recuado ? "bg-background" : ""}`}>
      <td className={`py-2 px-2 ${recuado ? "pl-12" : "pl-5"}`}>
        <div className="flex items-center gap-2.5">
          <Foto url={p.photo_url} nome={p.name} />
          <div className="min-w-0">
            <p className="font-medium truncate max-w-[260px] leading-tight">{p.name}</p>
            {!recuado && p.category ? (
              <span className="inline-flex items-center gap-1 mt-1 px-1.5 py-0.5 rounded text-[10px] font-medium bg-blue-500/15 text-blue-600 dark:text-blue-400 border border-blue-500/20">
                {p.category}
              </span>
            ) : null}
            {recuado && p.cmv <= 0 ? <span className="block text-[10px] text-amber-600 dark:text-amber-400 mt-0.5">sem ficha técnica</span> : null}
          </div>
        </div>
      </td>
      <CelulasValores linha={p} />
    </tr>
  );
}
